import { isServer } from '../../utils/_helper/isServer';

export const useIsStorybook = (): boolean => {
    if (isServer()) return false;
    return (
        ((window as unknown) as Record<string, string>)?.STORYBOOK_ENV ===
        'react'
    );
};
